import React from 'react'
import './index.less'
import { _ } from '@iskytrip/sdk'

class FloatingPanelView extends React.PureComponent {
	constructor(props) {
		super(props)

		const initOffsetY = window.innerHeight - this.props.anchors[0]
		this.startY = 0
		this.dataY = 0
		this.offsetY = initOffsetY

		this.state = {
			pulling: false,
			top: initOffsetY,
			maxTop: false,
		}
	}

	componentDidMount() {
		this.floatingPanel.addEventListener('touchstart', this._touchStart)
		this.floatingPanel.addEventListener('touchmove', this._touchMove, { passive: false })
		this.floatingPanel.addEventListener('touchend', this._touchEnd)
	}

	componentWillUnmount() {
		this.floatingPanel.removeEventListener('touchstart', this._touchStart)
		this.floatingPanel.removeEventListener('touchmove', this._touchMove, { passive: false })
		this.floatingPanel.removeEventListener('touchend', this._touchEnd)
	}

	_touchStart = (event) => {
		const touch = event.touches[0]
		this.startY = touch.clientY
	}

	_touchMove = (event) => {
		if (!this.state.maxTop) {
			event.preventDefault()
		}

		// 容器内容滚动高度大于0时禁止滑动事件放开默认滚动事件
		if (this.contentRef && this.contentRef.scrollTop > 0) {
			return
		}

		const { anchors = [] } = this.props
		const touch = event.touches[0]
		this.dataY = touch.clientY - this.startY

		let offsetY = this.dataY + this.offsetY
		if (
			offsetY < window.innerHeight - anchors[anchors.length - 1] ||
			offsetY > window.innerHeight - anchors[0] + 30
		) {
			return
		}

		this.setState({
			top: offsetY,
			pulling: true,
			maxTop: false,
		})
	}

	_touchEnd = (event) => {
		const { anchors = [], getPullingStatus } = this.props
		const toDownPull = () => {
			this.offsetY = window.innerHeight - anchors[0]

			this.setState({
				top: this.offsetY,
				pulling: false,
				maxTop: false,
			})

			if (_.isFunc(getPullingStatus)) getPullingStatus(false)
		}

		const toUpPull = () => {
			this.offsetY = window.innerHeight - anchors[anchors.length - 1]
			this.setState({
				top: this.offsetY,
				pulling: false,
				maxTop: true,
			})

			if (_.isFunc(getPullingStatus)) getPullingStatus(true)
		}

		if (
			this.offsetY + this.dataY >
			window.innerHeight - (anchors[anchors.length - 1] + anchors[0] - 300) / 2
		) {
			toDownPull()
			return
		}
		if (
			this.offsetY + this.dataY <
			window.innerHeight - (anchors[anchors.length - 1] + anchors[0] + 300) / 2
		) {
			toUpPull()
			return
		}
		if (this.dataY < 0) {
			toUpPull()
			return
		}
		if (this.dataY > 0) {
			toDownPull()
			return
		}
	}

	setHeight(height) {
		const initOffsetY = window.innerHeight - height
		this.offsetY = initOffsetY
		this.setState({
			top: initOffsetY,
		})
	}

	getEleRef(ref) {
		this.floatingPanel = ref
		if (this.props.getRef && _.isFunc(this.props.getRef)) {
			this.props.getRef(ref)
		}
	}

	render() {
		const { pulling, top } = this.state
		const { anchors = [] } = this.props
		const maxHeight = anchors[anchors.length - 1]

		return (
			<div
				ref={this.getEleRef.bind(this)}
				className='adm-floating-panel'
				style={{
					height: maxHeight,
					top,
				}}
			>
				<div
					className='adm-floating-panel-mask'
					style={{
						display: pulling ? 'block' : 'none',
					}}
				/>
				<div className='adm-floating-panel-header'>
					<div className='adm-floating-panel-bar' />
				</div>
				<div className='adm-floating-panel-content' ref={(ref) => (this.contentRef = ref)}>
					{this.props.children}
				</div>
			</div>
		)
	}
}

export default FloatingPanelView
